$(document).ready(function(){
   $.ajax({
     url:"/browsing_context_suggestions.json",
     dataType:'json',
     success:function(data){
       const country_code = data.detected_values.country.handle;
       console.log(`country = ${country_code}`)
       if(country_code == 'CA'){
          $('.product--us').hide();
          $('.redirection_message').show();
       }
     },
     error:function(error){
       console.log(error);
     }
   })
});